import Chip from '@mui/material/Chip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { useTranslation } from 'react-i18next';
import { formatCents } from './money';
import { canSetAside } from './setAside';

const COLORS = ['#1565c0', '#2e7d32', '#6a1b9a', '#ef6c00'];
const UNKNOWN_ACCOUNT_COLOR = '#9e9e9e';
const WRAP = { maxWidth: '100%', height: 'auto', py: 0.25, '& .MuiChip-label': { whiteSpace: 'normal', overflowWrap: 'anywhere', display: 'block' } };

export default function OutflowChip({ item, accountIndex = 0, onClick, setAside = false, onToggleSetAside }) {
  const { t } = useTranslation();
  if (item.display_only) {
    const label = item.label || item.kind;
    const amount = Number.isFinite(item.amount_cents) ? ` ${formatCents(item.amount_cents)}` : '';
    return <Chip size='small' variant='outlined' sx={{ ...WRAP, color: 'text.secondary' }} label={`${label}${amount}`} />;
  }
  const name = item.kind === 'check' ? `${item.payee} #${item.check_number}` : `${item.is_estimate ? '~' : ''}${item.payee}`;
  const isAside = setAside && canSetAside(item);
  const state = isAside ? t('calendar.states.setAside') : item.overdue ? t('calendar.states.overdue') : t(`calendar.states.${item.status}`);
  const color = accountIndex >= 0 ? COLORS[accountIndex % COLORS.length] : UNKNOWN_ACCOUNT_COLOR;
  const toggle = onToggleSetAside && canSetAside(item) ? {
    onDelete: () => onToggleSetAside(item),
    deleteIcon: isAside ? <VisibilityIcon aria-label={t('calendar.setAside.off')} /> : <VisibilityOffOutlinedIcon aria-label={t('calendar.setAside.on')} />,
  } : {};
  return (
    <Chip
      size='small'
      onClick={onClick ? () => onClick(item) : undefined}
      data-set-aside={isAside ? 'true' : undefined}
      sx={{ ...WRAP, borderLeft: `4px solid ${color}`, bgcolor: item.overdue && !isAside ? 'warning.light' : undefined,
        opacity: isAside ? 0.5 : 1, textDecoration: item.status === 'void' ? 'line-through' : undefined }}
      label={`${name} ${formatCents(item.amount_cents)} · ${state}`}
      {...toggle}
    />
  );
}
